import angular from 'angular'
import baseTemplate from 'views/common/template.html'
import log from './log'
import systemSetting from './systemsetting'
import permission from './permission'
import baseData from './basedata'
import settingCenter from './settingcenter'

export default angular.module('app.system', [systemSetting, log, baseData, permission, settingCenter])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state('system', {
            abstract: true,
            url: '/system',
            template: baseTemplate,
            title: '系统管理',
        })
    }]).name



// WEBPACK FOOTER //
// ./src/app/system/index.js